

<mat-slide-toggle class="m-4" color="primary" *ngIf="data.language == 'innerHtml'" [checked]="showparsed" (change)="changeView($event)"> Visualiser le résultat
</mat-slide-toggle>
<div *ngIf="showparsed" [innerHTML]="content"></div>
<ngx-codemirror [style.display]="showparsed ? 'none' : 'contents'" #codeMirror [(ngModel)]="content" [options]="options"></ngx-codemirror>